<template>
    <div class="form-content-wrapper">

        <div class="action-browse-wrapper">
            <b-form-file v-model="input" name="fotoBarangPendukung" :state="Boolean(suratEdaran)"
                drop-placeholder="Drop file here..." accept=".pdf," @input="browseFile()">
            </b-form-file>
            <b-button variant="cancelBtn" :disabled="loading">
                <i class="fa fa-upload mr-2"></i>
                Upload
            </b-button>
        </div>

        <b-table bordered hover show-empty :fields="fields" :busy="isBusy" :items="suratEdaran" responsive class="mb-3">

            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Loading data...</strong>
                </div>
            </template>
            <template v-slot:empty>
                Tidak ada data.
            </template>
            <template v-slot:cell(suratEdaran)="row">
                <iframe width="130px" height="130px"
                    :src="$companyId == 'PGI' ? $baseFilePath + row.item.filepath : row.item.filepath" />

                <!-- <a v-bind:href="$companyId == 'PGI' ? $baseFilePath + row.item.filepath : row.item.filepath"
                    target="_blank">
                </a> -->
            </template>
            <template v-slot:cell(aksi)="row">
                <b-button class="btn btn-sm mr-2" variant="pgiBtn"
                    :href="$companyId == 'PGI' ? $baseFilePath + row.item.filepath : row.item.filepath" target="_blank">
                    Lihat
                </b-button>
                <b-button class="btn btn-sm" variant="danger" :disabled="loading"
                    @click="confirmDeleteSuratEdaran(row.item.id)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </template>
        </b-table>

        <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
            <h4 class="text-center text-lg">LOADING ...</h4>
        </b-modal>

        <ModalConfirm id="confirm-hapus-suratEdaran" title="Konfirmasi hapus Surat Edaran" :isSubmitting="isBusy"
            desc="Apakah anda yakin untuk menghapus surat Edaran ini?" @submit="onDeleteSuratEdaran()" />
    </div>
</template>

<script>

export default {
    props: {
        rincian: {
            type: Object,
            required: true
        },
        idTipe: {
            type: Number,
            default: null
        }
    },
    components: {

    },
    data() {
        return {
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,

            loading: false,
            tipeBarang: null,
            activeId: null,
            suratEdaran: [],
            input: null,

            fields: [
                { key: "suratEdaran", label: "Surat Edaran" },
                { key: "aksi", label: "Aksi" }
            ],
        }
    },
    methods: {
        init() {
            this.initStatus = 0
            this.id = (this.idTipe != null) ? this.idTipe : this.$route.params.id

            let getSingleTipeBarang = this.$axios.get(`barang-tipe-v2/${this.id}`).then(response => {
                this.tipeBarang = response.data
                this.suratEdaran = response.data.suratEdaran
                let msg = this.$helper.getFlash()
                this.toggleBusy()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleTipeBarang]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })

        },
        fetchData() {
            this.toggleBusy()
            this.hargaSesuaiTahun = false
            this.$axios.get(`barang-tipe-v2/${this.id}`).then(response => {
                this.tipeBarang = response.data
                this.suratEdaran = response.data.suratEdaran
                this.toggleBusy()
            }).catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        confirmDeleteSuratEdaran(id) {
            this.activeId = id
            this.$bvModal.show("confirm-hapus-suratEdaran")
        },

        onDeleteSuratEdaran() {
            this.$bvModal.show('modal-loading')
            this.$axios.post(`barang-tipe-v2/delete-surat-edaran/` + this.activeId).then(() => {

                this.$bvModal.hide("confirm-hapus-suratEdaran")
                this.$helper.toastSucc(this, 'Data berhasil dihapus')
                this.fetchData()
                this.$bvModal.hide('modal-loading')
            })
                .catch(error => {
                    this.$bvModal.hide('modal-loading')
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
        },

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        browseFile() {
            this.loading = true
            this.$bvModal.show('modal-loading')
            let formData = new FormData();

            formData.append('tipeId', this.id);
            formData.append('file', this.input);

            this.$axios.post(`barang-tipe-v2/insert-surat-edaran`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(() => {
                this.fetchData()
                this.$bvModal.hide('modal-loading')
                this.loading = false
                this.$helper.toastSucc(this, "Surat Edaran berhasil diupload!")
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.initStatus = -1;
                this.loading = false
                this.$bvModal.hide('modal-loading')
            });
        },

    },
    watch: {

        //----------------- Pantau Filter Jenis Barang -----------------

    },
    created() {
        this.init()
    }
}
</script>